<template>
  <section id="team" class="section">
    <Container>
      <div class="section-head">
        <p class="eyebrow" style="justify-content: center">Meet the Team</p>
        <h2 class="section-title">The People Behind Deyoke Foods</h2>
        <p class="section-subtitle">
          A small, dedicated team turning turkey berry into everyday wellness —
          from the farm to your cup.
        </p>
      </div>

      <CEOMember
        :key="ceo.name"
        :image="ceo.image"
        :role="ceo.role"
        :degree="ceo.degree"
        :name="ceo.name"
      />

      <div class="team-grid">
        <TeamMember
          v-for="member in team"
          :key="member.name"
          :image="member.image"
          :role="member.role"
          :degree="member.degree"
          :name="member.name"
        />
      </div>
    </Container>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import TeamMember from './TeamMember/TeamMember.vue';
import CEOMember from './TeamMember/CEOMember.vue';
import Container from '@/components/Container/Container.vue';

const team = ref([
  {
    image: require('@/assets/Emmanuel.jpg'),
    role: 'Communication & Quality Assurance Lead (co-founder)',
    degree: 'Bsc. Agricultural Engineering',
    name: 'Emmanuel Adjei',
  },
  {
    image: require('@/assets/Victoria.jpg'),
    role: 'Marketing & Finance Lead (co-founder)',
    degree: 'Bsc. Entrepreneurship',
    name: 'Baffour Frimpong Victoria',
  },
  {
    image: require('@/assets/Martin.jpg'),
    role: 'Chief Operations Officer (co-founder)',
    degree: 'Bsc. Mechanical Engineering',
    name: 'Martin Atampugre',
  },
]);

const ceo = ref({
    image: require('@/assets/Joshua.jpg'),
    role: 'CEO, Production Lead (Founder)',
    degree: 'Bsc. Agricultural Engineering',
    name: 'Akanzige Tanga Joshua',
})
</script>

<style scoped>
.team-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
}

@media (max-width: 1023px) {
  .team-grid {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}

@media (max-width: 767px) {
  .team-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>
